export default function stockByEmb(stockPositive, groupLots, stockDate) {
  const token = localStorage.getItem("token");
  print(token, stockPositive || "", groupLots || "", stockDate || "");
}
function print(token, stockPositive, groupLots, stockDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/products/stock/packing/?auth=${token}&stockPositive=${stockPositive}&groupLots=${groupLots}&stockDate=${encodeURIComponent(stockDate)}`
  );
}
